"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { hidden } from './styles.js';

var _excluded = ["tag", "above", "below"];
/**
 * Hides child components at above/below certain breakpoints.
 */
var Hidden = function Hidden(props) {
  var _props$tag = props.tag,
    tag = _props$tag === undefined ? 'div' : _props$tag,
    above = props.above,
    below = props.below,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(hidden, _extends({
    "data-testid": "elemental-Hidden-".concat(above ? 'above' : 'below', "-").concat(above ? above : below)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    as: tag,
    $above: above,
    $below: below
  }, rest));
};

export { Hidden };
